import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { PartnerPermission, PartnerPermissionName } from 'api/partner/types';
import { translationKeyForAccessLevelLabel } from '../../utils';
import { CellRendererParams } from './types';

interface Props extends CellRendererParams {
  partnerPermissions: PartnerPermission[];
}
export const AccessLevelRenderer: FC<Props> = ({
  value,
  partnerPermissions,
}) => {
  const partnerPermissionSetName = partnerPermissions.find(
    (x) => x.partnerPermissionSetId === value.partnerPermissionSetId,
  )?.partnerPermissionSetName;

  return partnerPermissionSetName != null ? (
    <FormattedMessage
      id={translationKeyForAccessLevelLabel(partnerPermissionSetName)}
    />
  ) : (
    <>-</>
  );
};
const getIndexForPermissionName = (
  permission: PartnerPermissionName,
): number => {
  switch (permission) {
    case PartnerPermissionName.Permissive:
      return 1;
    case PartnerPermissionName.Moderate:
      return 2;
    case PartnerPermissionName.Restricted:
      return 3;
    default:
      return 0;
  }
};

export const AccessLevelSorter = (
  partnerPermissionSetNameA: PartnerPermissionName,
  partnerPermissionSetNameB: PartnerPermissionName,
): number =>
  getIndexForPermissionName(partnerPermissionSetNameA) -
  getIndexForPermissionName(partnerPermissionSetNameB);
